import './form-value.scss';
var FormValue = /** @class */ /*@__PURE__*/ (function () {
    function FormValue() {
    }
    return FormValue;
}());
export { FormValue };
